import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { DARK_BLUE } from "theme/colors";

import type { ActiveTab } from "../ActivityLibrarySidebar/ActivityLibrarySidebar";

interface DropZoneIndicatorProps {
  activityType: ActiveTab;
}

export const DropZoneIndicator: React.FC<DropZoneIndicatorProps> = ({ activityType }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Typography variant="subtitle1" color={DARK_BLUE[50]}>
        {t("treatment.editor.add_activity_here", { activityType })}
      </Typography>
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 40px 24px;
  background-color: ${({ theme }) => theme.colors.redesign.db1};
  border: 1px dashed ${({ theme }) => theme.colors.redesign.db40};
  border-radius: 8px;
`;

export const DropZoneContainer = styled.div`
  box-sizing: border-box;
  padding: 4px;
  border: 2px solid transparent;
  border-radius: 12px;

  &.is-error {
    background-color: ${({ theme }) => theme.colors.redesign.r10};
    border-color: ${({ theme }) => theme.colors.redesign.r100};
  }

  &.is-over {
    background-color: ${({ theme }) => theme.colors.redesign.b5};
    border-color: ${({ theme }) => theme.colors.redesign.b100};
  }
`;
